import React from 'react'
import { useStore } from 'services/store'

/**
 * Return source based on if light or darkmode
 * @param lightModeSrc
 * @param darkModeSrc
 * @returns
 */
export const useThemeBasedImage = (lightModeSrc: string, darkModeSrc: string) => {
  const { isDarkMode } = useStore()
  const [source, setSource] = React.useState<string>(lightModeSrc)

  React.useEffect(() => {
    setSource(isDarkMode ? darkModeSrc : lightModeSrc)
  }, [isDarkMode])
  return source
}
